import { IngredientCreateStockPage } from './../ingredient-create-stock/ingredient-create-stock';
import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IngredientsServices } from "../../services";
import { Globals } from "../../../../globals";
import { ProvidersServices } from "../../../providers/services";
import { StaticsServices } from '../../../services/statics';
import { TranslateService } from '@ngx-translate/core';
import { AnalyticsServices } from '../../../services/analyticsServices';

/**
 * Generated class for the IngredientCreateInfoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-ingredient-create-info',
  templateUrl: 'ingredient-create-info.html',
})
export class IngredientCreateInfoPage {

  public form: FormGroup;
  ingredient_name: any;
  ingredient_uid: string;
  update_state: boolean = false;
  value_changes: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public ingredientServices: IngredientsServices,
    public fb: FormBuilder,
    public globals: Globals,
    private toastCtrl: ToastController,
    public providersServices: ProvidersServices,
    public staticsServices: StaticsServices,
    public translate: TranslateService,
    public analyticsServices: AnalyticsServices) {

    //Params
    this.update_state = this.navParams.get('update_state');
    this.ingredient_name = this.navParams.get('ingredient_name');

    //Si hacemos update adamptamos la informacion
    if (this.update_state) {
      this.ingredientServices.ingredient_tags = this.navParams.get('tags');
      this.ingredient_uid = this.navParams.get('ingredient_uid');

      var stock_max = 0;
      if (this.navParams.get('stock_max')) {
        stock_max = this.navParams.get('stock_max')
      }

      this.form = fb.group({
        name: [this.navParams.get('ingredient_name'), Validators.compose([Validators.required])],
        measurement: [this.navParams.get('measurement')],
        stock: [this.navParams.get('stock')],
        stock_alert: [this.navParams.get('stock_alert')],
        stock_max: [stock_max],
        sub_recipe: [false],
      });
    } else {
      this.ingredientServices.ingredient_tags = Array();

      this.form = fb.group({
        name: ['', Validators.compose([Validators.required])],
        measurement: ['kg'],
        stock: [0],
        stock_alert: [0],
        stock_max: [0],
        sub_recipe: [false],
      });
    }


  }

  submit() {
    if (this.form.valid) {
      if (!this.update_state) {
        this.insert();
      } else {
        this.update();
      }
    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-introduce-nombre-ingrediente-continuar'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }

  insert() {
    this.ingredientServices.afs.collection('ingredients').add({
      'UID_RESTAURANT': this.globals.restaurant_uid,
      'name': this.form.value.name,
      'measurement': 'kg',
      'stock': 0,
      'stock_alert': 0,
      'stock_max': 0,
      'sub_recipe': false,
      'tags': this.ingredientServices.ingredient_tags,
      'tags_static': this.ingredientServices.ingredient_tags.toString(),
      'price_static': 0,
      'provider_static': this.translate.instant('general-sin-proveedor'),
      'providers': Array(),
      'created_at': new Date(),
      'updated_at': new Date(),
    }).then(doc => {
      this.globals.GAtrackView('Ingredients', 'Ingredients - Name - Create', this.globals.restaurant.email, 'Create/Update', 'Create name', 'Ingredients', this.form.value.name);
      this.analyticsServices.trackingExpStock('create_ingredient', this.globals.tracking_exp['create_ingredient'], doc.id);
      this.finisher();
      //send datastore
      this.sendData();
      //Get the UID Document
      for (let value of this.ingredientServices.ingredient_tags) {
        this.globals.dataSet('ingredient_tag', value, '', this.form.value.name);
      }
      this.ingredientServices.ingredient_tags = null;
      this.navCtrl.push(IngredientCreateStockPage, {
        update_state: false,
        ingredient_uid: doc.id,
        ingredient_name: this.form.value.name,
        ingredient_measurement: this.form.value.measurement
      });
      //this.value_changes.unsuscribe();
    });
  }

  update() {
    this.ingredientServices.afs.collection('ingredients').doc(this.ingredient_uid).update({
      'name': this.form.value.name,
      'measurement': this.form.value.measurement,
      'stock': this.form.value.stock,
      'stock_alert': this.form.value.stock_alert,
      'stock_max': this.form.value.stock_max,
      'tags': this.ingredientServices.ingredient_tags,
      'tags_static': this.ingredientServices.ingredient_tags.toString(),
      'sub_recipe': false,
      'updated_user': this.globals.user_name,
      'updated_at': new Date(),
    }).then(() => {
      //send datastore
      this.sendData();
      //
      this.globals.GAtrackView('Ingredients', 'Ingredients - Name - Update', this.globals.restaurant.email, 'Create/Update', 'Update name', 'Ingredients', this.form.value.name);
      this.staticsServices.changeStateStaticWait(true);
      this.navCtrl.pop();
    });
  }


  sendData() {
    var extra = {
      "min_stock": this.form.value.stock_alert,
      "max_stock": this.form.value.stock_max,
    };
    this.globals.dataSet('ingredient_name', this.form.value.name, '', JSON.stringify(extra));
    for (let value of this.ingredientServices.ingredient_tags) {
      this.globals.dataSet('ingredient_tag', value, '', this.form.value.name);
    }
  }

  finisher() {
    if (this.globals.restaurant.plg_stock_finisher === undefined || this.globals.restaurant.plg_stock_finisher === false) {
      this.ingredientServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
        plg_stock_finisher: true
      });
      this.globals.restaurant.plg_stock_finisher = true;
      this.analyticsServices.trackingExpStock('finisher', this.globals.tracking_exp['finisher'], '');
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/ingredients/ingredient-create/ingredient-create-info/ingredient-create-info.ts